import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { IoTrash } from "react-icons/io5";
import * as yup from "yup";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import DrawerAndModalWrapper from "../../shared/ui/Drawer/DrawerAndModalWrapper";
import FormikLabeledInput from "../../shared/ui/Form/FormikLabeledInput";
import Info from "../../shared/ui/Info";

const AdditionalInput = ({ isOpen, onClose, inputs, setInputs }) => {
    const ref = useRef();
    const [showInputs, setShowInputs] = useState(false);

    const handleAddMoreInputs = (values, actions) => {
        setInputs([...inputs, values]);
        actions.resetForm();
    };

    const handleDeleteInput = (index) => {
        setInputs(inputs.filter((_, i) => i !== index));
    };

    const handleSubmit = async () => {
        let { dirty, isValid, validateForm, resetForm, values, setTouched } =
            ref.current || {};

        if (!dirty && isValid) {
            onClose(false);
            setShowInputs(false);
            resetForm();
        } else if (dirty && !isValid) {
            setTouched({
                itemDescription: true,
                itemPrice: true,
                itemGst: true,
            });
            await validateForm();
        } else if (dirty && isValid) {
            onClose(false);
            setShowInputs(false);
            setInputs([...inputs, values]);
            resetForm();
        } else if (inputs.length === 0) {
            setInputs([]);
            onClose();
        }
    };
    const handleClose = () => {
        onClose(false);
        setShowInputs(false);
    };

    return (
        <DrawerAndModalWrapper
            isOpen={isOpen}
            onClose={handleClose}
            // contentClass="bg-white"
            modalContentClass="bg-white"
        >
            <>
                <div className="mb-2">
                    <div className="grid grid-cols-2 gap-0.5 bg-gray-60 text-white p-0.8 rounded font-vietnam">
                        <P className="">Description</P>
                        <P className="">Value</P>
                    </div>
                    {inputs.length === 0 && (
                        <Info message="No data available" />
                    )}

                    {inputs.map((item, index) => (
                        <div
                            key={index}
                            className="grid grid-cols-2 py-0.8 border-b border-b-gray-200 gap-0.5 p-0.8"
                        >
                            <div>
                                <P className="line-clamp-1">
                                    {item.itemDescription}
                                </P>
                            </div>
                            <div className="flex items-center justify-between">
                                <P className="flex-1">{item.itemPrice}</P>
                                <button
                                    onClick={() => handleDeleteInput(index)}
                                    className="hover:text-red"
                                >
                                    <IoTrash size={20} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex flex-col">
                    {showInputs ? (
                        <Formik
                            onSubmit={handleAddMoreInputs}
                            initialValues={{
                                itemDescription: "",
                                itemGst: "",
                                itemPrice: "",
                            }}
                            validationSchema={yup.object().shape({
                                itemDescription: yup
                                    .string()
                                    .required()
                                    .label("Description"),
                                itemPrice: yup
                                    .number()
                                    .typeError("Value must be numeric values")
                                    .required()
                                    .label("Value"),
                                itemGst: yup
                                    .number()
                                    .typeError("GST must be numeric values")
                                    .max(100)
                                    .label("GST"),
                            })}
                            innerRef={ref}
                        >
                            {() => (
                                <Form>
                                    <div className="flex flex-col gap-1">
                                        <FormikLabeledInput
                                            label="Description"
                                            name="itemDescription"
                                            placeholder="Enter description"
                                        />
                                        <FormikLabeledInput
                                            label="Value"
                                            name="itemPrice"
                                            placeholder="Enter value"
                                        />
                                        <FormikLabeledInput
                                            label="GST Percentage"
                                            name="itemGst"
                                            placeholder="Enter gst"
                                        />
                                    </div>

                                    <div>
                                        <button
                                            type="submit"
                                            className=" mr-3.2 md:mr-3.6 bg-transparent inline-block items-start underline text-blue-100 text-left text-base"
                                        >
                                            Add more
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        <div>
                            <button
                                onClick={() => setShowInputs(true)}
                                className=" mr-3.2 md:mr-3.6 bg-transparent inline-block items-start underline text-blue-100 text-left text-base"
                            >
                                Add row
                            </button>
                        </div>
                    )}
                </div>

                <div className="flex justify-center mt-2 ">
                    <Button onClick={handleSubmit} className="w-full sm:w-3/6">
                        Submit
                    </Button>
                </div>
            </>
        </DrawerAndModalWrapper>
    );
};

export default AdditionalInput;
